<template>
  <div class="modal fade show" style="display:block;">
    <div
      @click="tryClose"
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    >
    <div class="modal-content">
      <div class="modal-header">
      <h5 v-if="props.title">{{props.title}}</h5>
      <button
        type="button"
        class="close col-xs-1"
        style="padding:0;"
        @click="close"
      >
        <i class="tim-icons icon-simple-remove"></i>
      </button>
    </div>
    <div class="modal-body">
        <component
          :is="component"
          v-bind="props.props"
          @close="close"
        ></component>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal',
  components: {
  },
  props: {
    title: String,
    id: Number,
    props: {type:Object,default(){return{}}},
    component: {
      type: [Object, Function]
    },
    showClose: {
      type: Boolean,
      default: true
    },
    clickHandler: Function
  },
  data() {
    return {
      elmHeight: 0
    };
  },
  computed: {
  },
  methods: {
    close() {
      this.$emit('close', this.id);
    },
    tryClose(evt) {
      if (this.clickHandler) {
        this.clickHandler(evt, this);
      }
    }
  },
  mounted() {
    this.elmHeight = this.$el.clientHeight;
  }
};
</script>
<style lang="scss">
.modal.show{
  display:block;
}
.modal-dialog{
  
}
.modal-overlay{

}

</style>
